<template>
  <span class="pre-line">{{ text | profanity }}</span>
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.pre-line {
  white-space: pre-line;
}
</style>
